import type { BrandUnion, PaymentServiceComponents } from '@core/types'
import type { PspUnion, MethodUnion, MethodEnum, CashierDepositResponseData } from '@payments/types'

export enum TransactionStateEnum {
    FAILED = 'failed',
    SUCCESSFUL = 'successful',
    PROCESSING = 'processing',
    INCONSISTENT = 'inconsistent',
}

export type TransactionStateUnion = `${TransactionStateEnum}`

export enum DepositViewEnum {
    ACCOUNTS = 'PaymentsDepositViewsAccounts',
    CASHIER_METHODS = 'PaymentsDepositViewsCashierMethods',
    CASHIER_HOSTED_FIELDS = 'PaymentsDepositViewsCashierHostedFields',
    CASHIER_AMOUNT = 'PaymentsDepositViewsCashierAmount',
    CREDIT_AND_PAYMENT = 'PaymentsDepositViewsCreditAndPayment',
    CARD_CONSENT = 'PaymentsDepositViewsCardConsent',
}

export type DepositViewUnion = `${DepositViewEnum}`

export type UnifiedDepositResponse = CashierDepositResponseData | PaymentServiceComponents['schemas']['QuickDepositResponse']

export interface PaymentIQDepositConfig {
    merchant_id: string
    customer_number: string
}

export interface PaymentMethodFee {
    flatFee: string
    maxAmount: string
    minAmount: string
    paymentMethod: MethodEnum
    percentageFee: string
}

export interface DepositConfig {
    fees: PaymentMethodFee[] | []
    limits: {
        min: string
        max: string
    }
    numberOfDeposits: number
    options: string[]
}

export interface PaymentMethod {
    accountLimitReached: boolean
    paymentMethod: MethodUnion
    psp: PspUnion
}

export interface PaymentMethodResponse {
    options: PaymentMethod[]
}

export interface RedirectUrls {
    cancelUrl: string
    failureUrl: string
    pendingUrl: string
    successUrl: string
}

export interface EpayPspClient {
    clientUrl: string
    key: string
    attributes: EpayPspClientAttributes
}

export interface EpayOptions {
    success: boolean
    message: string
    pspClient: EpayPspClient
    providerTransactionId: string | null
    SCARedirect: string | null
}

export interface EpayPspClientAttributes {
    id: string
    currency: string
    expiresAt: string
    instantCapture: string
    amount: number
    scaMode: string
    timeout: number
    notificationUrl: string
    pointOfSaleId: string
    reference: string
    state: string
    createdAt: string
    reportFailure: boolean
    attributes: {
        userId: number
        brand: BrandUnion
        pspData: null
        paymentMethodId: string | null
        ipAddress: string
        userAgent: string
    }
    preAuthUrl: string
    successUrl: string
    failureUrl: string
}
